module.exports = __webpack_public_path__ + "static/media/Tier_3.a43bda7b.svg";